import "floating-vue/dist/style.css";

import FloatingVue from "floating-vue";
import type { App } from "vue";

export default {
	install: (app: App) => {
		app.use(FloatingVue, {
			themes: {
				nav: {
					$extend: "tooltip",
					$resetCss: true,
				},
			},
		});
	},
};
